// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
}

.user-table thead {
  background: #f5f5f5;
}

.user-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  border-bottom: 2px solid #e0e0e0;
}

.user-table td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
}

.user-table tbody tr:hover {
  background: #f9f9f9;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  margin-right: 5px;
}

.status-badge.active {
  background: #4caf50;
  color: white;
}

.status-badge.inactive {
  background: #f44336;
  color: white;
}

.status-badge.trial {
  background: #ff9800;
  color: white;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-buttons button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.action-buttons button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.btn-view {
  background: #1976d2;
  color: white;
}

.btn-view:hover {
  background: #1565c0;
}

.btn-reset {
  background: #ff9800;
  color: white;
}

.btn-reset:hover {
  background: #f57c00;
}

.btn-disable {
  background: #f44336;
  color: white;
}

.btn-disable:hover {
  background: #d32f2f;
}

.btn-enable {
  background: #4caf50;
  color: white;
}

.btn-enable:hover {
  background: #388e3c;
}

.user-table-loading,
.user-table-empty {
  text-align: center;
  padding: 40px;
  color: #666;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .user-table-container {
    overflow-x: scroll;
  }
}

/* Feature badges */
.feature-badges {
  display: flex;
  gap: 4px;
  font-size: 14px;
}

.feature-dot {
  opacity: 1;
  transition: opacity 0.2s;
}

.feature-dot.off {
  opacity: 0.25;
  filter: grayscale(1);
}

/* Checkbox column */
.col-checkbox {
  width: 36px;
  text-align: center;
}

.col-checkbox input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/admin/components/UserTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".user-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.user-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.user-table thead {\n  background: #f5f5f5;\n}\n\n.user-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.user-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n}\n\n.user-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-right: 5px;\n}\n\n.status-badge.active {\n  background: #4caf50;\n  color: white;\n}\n\n.status-badge.inactive {\n  background: #f44336;\n  color: white;\n}\n\n.status-badge.trial {\n  background: #ff9800;\n  color: white;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-buttons button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n}\n\n.action-buttons button:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.btn-view {\n  background: #1976d2;\n  color: white;\n}\n\n.btn-view:hover {\n  background: #1565c0;\n}\n\n.btn-reset {\n  background: #ff9800;\n  color: white;\n}\n\n.btn-reset:hover {\n  background: #f57c00;\n}\n\n.btn-disable {\n  background: #f44336;\n  color: white;\n}\n\n.btn-disable:hover {\n  background: #d32f2f;\n}\n\n.btn-enable {\n  background: #4caf50;\n  color: white;\n}\n\n.btn-enable:hover {\n  background: #388e3c;\n}\n\n.user-table-loading,\n.user-table-empty {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .user-table-container {\n    overflow-x: scroll;\n  }\n}\n\n/* Feature badges */\n.feature-badges {\n  display: flex;\n  gap: 4px;\n  font-size: 14px;\n}\n\n.feature-dot {\n  opacity: 1;\n  transition: opacity 0.2s;\n}\n\n.feature-dot.off {\n  opacity: 0.25;\n  filter: grayscale(1);\n}\n\n/* Checkbox column */\n.col-checkbox {\n  width: 36px;\n  text-align: center;\n}\n\n.col-checkbox input[type=\"checkbox\"] {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
